import React from 'react';

import { MemoizedL3PrivateRoutes } from 'Deer/components/RoutingComps/MemoizedL3PrivateRoutes';

const ViewsReviews = () => <MemoizedL3PrivateRoutes />;

export default ViewsReviews;
